import styled from "@emotion/styled";
import { Alert } from "@kaltura/ds-react-components";
import { generalHtmlStyles } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";

const StyledAlert = styled(Alert)(({ theme }) => [
    generalHtmlStyles(theme),
    {
        "& .board-message-text": { color: theme.kaltura.palette.tone1 },
    },
]);

export interface NotificationProps {
    message: string;
}

/**
 * "items pending approve" notification component
 */
export const Notification = ({ message }: NotificationProps) => {
    return (
        <StyledAlert classes={{ message: "channel-notification" }} severity={"info"}>
            <span>
                {message}
                &nbsp;
                <a href={window.location.href}>{translate("Refresh Now")}</a>
            </span>
        </StyledAlert>
    );
};

export default Notification;
